<div class="decal-host">
  <ng-content></ng-content>
  @if (decal?.urlAsset) {
    <img
      class="decal-img"
      [class.tl]="anchor === 'top-left'"
      [class.tr]="anchor === 'top-right'"
      [class.bl]="anchor === 'bottom-left'"
      [class.br]="anchor === 'bottom-right'"
      [class.cover]="anchor === 'cover'"
      [src]="decal!.urlAsset"
      [style.width.%]="anchor === 'cover' ? null : (decal?.tamanoPct ?? 35)"
      alt=""
    />
  }
</div>
